var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.headers,"value":_vm.selectedColumn,"item-text":"text","item-value":"value","clearable":""},on:{"input":_vm.selectColumn}})
}
var staticRenderFns = []

export { render, staticRenderFns }